import { REFRESH_TOKEN } from '../constants';

const BASE_URL = process.env.REACT_APP_API_URL;

let refreshPromise: Promise<string | null> | null = null;

async function doRefresh(): Promise<string | null> {
  const refreshToken =
    localStorage.getItem('refreshToken') || sessionStorage.getItem('refreshToken') || '';

  if (!refreshToken) return null;

  try {
    const res = await fetch(`${BASE_URL}/user/refresh`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refreshToken }),
    });

    const data = await res.json();

    if (data?.data?.accessToken) {
      const storage = localStorage.getItem(REFRESH_TOKEN) ? localStorage : sessionStorage;
      storage.setItem('accessToken', data.data.accessToken);
      return data.data.accessToken;
    }
  } catch {
    // refresh failed
  }

  // Refresh failed — clear everything
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  sessionStorage.removeItem('accessToken');
  sessionStorage.removeItem('refreshToken');
  return null;
}
export async function refreshAccessToken(): Promise<string | null> {
  // If a refresh is already in flight, wait for it instead of firing another
  if (refreshPromise) return refreshPromise;

  refreshPromise = doRefresh();
  const result = await refreshPromise;
  refreshPromise = null;
  return result;
}
